import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

type CreateBffClientOptions = {
  /** Reviews (and other store-scoped routes) require x-store-id; catalog/carts do not. */
  includeStoreScope?: boolean;
};

export function createBffClient(options?: CreateBffClientOptions) {
  const headers: Record<string, string> = {};
  if (options?.includeStoreScope && env.FUNNELS_STORE_ID) {
    headers['X-Store-ID'] = env.FUNNELS_STORE_ID;
  }

  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
    ...(Object.keys(headers).length > 0 ? { headers } : {}),
  });
}
